import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ChangePassword from './pages/ChangePassword';

import urls, { changePasswordUrl } from './urls';


const ChangePasswordRoute = () => {
  return (
    <Switch>
      <Route exact path={changePasswordUrl()} component={ChangePassword} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default ChangePasswordRoute;
